








import { defineComponent, PropType } from '@vue/composition-api';
import { ArchiveInfo } from '@oare/types';
import ArchiveInfoComponent from './ArchiveInfo.vue';

export default defineComponent({
  name: 'ArchivesList',
  components: {
    ArchiveInfoComponent,
  },
  props: {
    archives: {
      type: Array as PropType<ArchiveInfo[]>,
      required: true,
    },
  },
});
